// extracted by mini-css-extract-plugin
export default {"container":"components-login-confirmation-code-module__container"};